import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#FAB446"
  }} d="M473.655,88.276H38.345C17.167,88.276,0,105.443,0,126.621v73.471h512v-73.471  C512,105.443,494.833,88.276,473.655,88.276z" /><path style={{
    fill: "#73AF00"
  }} d="M0,385.379c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345  v-73.471H0V385.379z" /><rect y={200.09} style={{
    fill: "#F5F5F5"
  }} width={512} height={111.81} /><g><path style={{
      fill: "#41479B"
    }} d="M256,303.448c-26.164,0-47.448-21.284-47.448-47.448s21.284-47.448,47.448-47.448   s47.448,21.284,47.448,47.448S282.164,303.448,256,303.448z M256,217.379c-21.298,0-38.621,17.323-38.621,38.621   s17.323,38.621,38.621,38.621s38.621-17.323,38.621-38.621S277.298,217.379,256,217.379z" /><circle style={{
      fill: "#41479B"
    }} cx={256} cy={256} r={5.379} /><polygon style={{
      fill: "#41479B"
    }} points="256,256.807 242.33,258.187 212.966,256.807 212.966,255.193 242.33,253.813 256,255.193     " /><polygon style={{
      fill: "#41479B"
    }} points="256,256.807 269.67,258.187 299.034,256.807 299.034,255.193 269.67,253.813 256,255.193     " /><polygon style={{
      fill: "#41479B"
    }} points="255.193,256 253.813,242.33 255.193,212.966 256.807,212.966 258.187,242.33 256.807,256     " /><polygon style={{
      fill: "#41479B"
    }} points="255.193,256 253.813,269.67 255.193,299.034 256.807,299.034 258.187,269.67 256.807,256     " /><polygon style={{
      fill: "#41479B"
    }} points="255.43,256.57 244.788,247.881 225,226.141 226.141,225 247.881,244.788 256.57,255.43  " /><polygon style={{
      fill: "#41479B"
    }} points="255.43,256.57 264.119,267.212 285.859,287 287,285.859 267.212,264.119 256.57,255.43  " /><polygon style={{
      fill: "#41479B"
    }} points="255.43,255.43 264.119,244.788 285.859,225 287,226.141 267.212,247.881 256.57,256.57  " /><polygon style={{
      fill: "#41479B"
    }} points="255.43,255.43 244.788,264.119 225,285.859 226.141,287 247.881,267.212 256.57,256.57  " /><polygon style={{
      fill: "#41479B"
    }} points="256.309,256.746 244.207,263.252 216.551,273.214 215.933,271.723 242.534,259.211    255.691,255.254  " /><polygon style={{
      fill: "#41479B"
    }} points="256.309,256.746 269.466,252.789 296.067,240.277 295.449,238.786 267.793,248.748    255.691,255.254  " /><polygon style={{
      fill: "#41479B"
    }} points="255.254,256.309 248.748,244.207 238.786,216.551 240.277,215.933 252.789,242.534    256.746,255.691  " /><polygon style={{
      fill: "#41479B"
    }} points="255.254,256.309 259.211,269.466 271.723,296.067 273.214,295.449 263.252,267.793    256.746,255.691  " /><polygon style={{
      fill: "#41479B"
    }} points="255.691,256.746 242.534,252.789 215.933,240.277 216.551,238.786 244.207,248.748    256.309,255.254  " /><polygon style={{
      fill: "#41479B"
    }} points="255.691,256.746 267.793,263.252 295.449,273.214 296.067,271.723 269.466,259.211    256.309,255.254  " /><polygon style={{
      fill: "#41479B"
    }} points="255.254,255.691 259.211,242.534 271.723,215.933 273.214,216.551 263.252,244.207    256.746,256.309  " /><polygon style={{
      fill: "#41479B"
    }} points="255.254,255.691 248.748,267.793 238.786,295.449 240.277,296.067 252.789,269.466    256.746,256.309  " /></g><circle style={{
    fill: "#F5F5F5"
  }} cx={256} cy={256} r={7.256} /><circle style={{
    fill: "#41479B"
  }} cx={256} cy={256} r={4.351} /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };